export default "__VITE_ASSET__CrAJPjRr__"